import React, { Component } from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex";
import MappingListOutput from "./../Micro/MappingListOutput.js";

const multiple = nota.global.multiple;

const StyledSearchListBlock = styled.div`
  width: 100%;
  #searchListBlock {
    display: grid;
    grid-gap: 0px; /* 4px */
    grid-template-columns: repeat(auto-fill, minmax(${(props) => props.gridSize}px, 1fr));
    grid-template-rows: auto;
    grid-auto-flow: dense;
    .selectThumbContainer {
      display: block;
    }
  }
`;

const StyledBlank = styled.div`
  width: 100%;
  height: ${(props) => props.height + "px"};
`;

class SearchListBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridSize: nota.global.searchGrid.width,
      isVisible: true,
    };
    this.container = React.createRef();

    this.containerHeight = 2895;
  }

  componentDidMount() {
    // Trigger Test => window.dispatchEvent(new Event('resize'));
    window.addEventListener("resize", this.updateGridDimensions);
    this.updateGridDimensions();

    const lazyLoad = (target) => {
      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting !== this.state.isVisible) {
              if (!entry.isIntersecting) {
                this.containerHeight = entry.boundingClientRect.height;
              }
              this.setState({ isVisible: entry.isIntersecting });
            }
          });
        },
        { rootMargin: "250px" }
      );

      io.observe(target);
    };

    lazyLoad(this.container.current);

    if (this.state.isVisible && this.props.onSearchListBlockVisibleChange) {
      this.props.onSearchListBlockVisibleChange(this.props.index, this.state.isVisible);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isVisible !== prevState.isVisible && this.props.onSearchListBlockVisibleChange) {
      this.props.onSearchListBlockVisibleChange(this.props.index, this.state.isVisible);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateGridDimensions);
  }

  updateGridDimensions = () => {
    if (this.container.current !== null && this.container.current !== undefined && this.container.current.offsetWidth !== null && this.container.current.offsetWidth !== undefined) {
      let count = this.container.current.offsetWidth / nota.global.searchGrid.width;

      while ((120 / Math.floor(count)) % 1 != 0) {
        count--;
      }

      this.setState({ gridSize: this.container.current.offsetWidth / count });
    }
  };

  render() {
    if (!this.props.data) return null;

    return (
      <div ref={this.container} style={this.state.isVisible ? null : { visibility: "hidden" }}>
        <StyledSearchListBlock gridSize={this.state.gridSize}>
          <NanoFlex id={"searchListBlock"} flexWrap={"wrap"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            <MappingListOutput data={this.props.data} isLoadingDone={false} selectable={this.props.selectable} selectedIds={this.props.selectedIds} selectMode={this.props.selectMode} onSelectedChange={this.props.onSelectedChange} hasBiggerThumb={this.props.hasBiggerThumb} hideSelection={this.props.hideSelection} />
          </NanoFlex>
        </StyledSearchListBlock>
      </div>
    );
  }
}

// Set default props
SearchListBlock.defaultProps = { data: null };

export default SearchListBlock;

// --- // Documentation // --- //
/*

import SearchListBlock from './../Macro/SearchListBlock.js';

<SearchListBlock data={null} />
*/
